<template>
    <div class="walletPage">
        <div class="login-bg">
          <div class="bouns" :style="{width:bounsWidth+'px'}">  
            <div class="totalCoin">
                <p class="totalTitle"><i class="fa fa-money"></i>总资产</p>
                <p class="totalNum"><span style="font-size: 34px;">49</span><span>.585858</span></p>
            </div>
            <div class="coin">
               <div class="grant">
                  <p class="count"><span style="font-size: 22px;">19</span><span>.555</span></p>
                  <p class="text">静态通证</p>
                </div>          
                <div class="put">
                  <p class="count"><span style="font-size: 22px;">24</span><span>.333</span></p>
                  <p class="text">动态通证</p>
                </div>  
                <div class="put">
                  <p class="count"><span style="font-size: 22px;">24</span><span>.333</span></p>
                  <p class="text">花粉</p>
                </div>  
            </div>
          </div>
      </div>
      <div class="actived-list">
        <div class="actived-item">
          <a href="#" class="">
            <img src=" ../static/IHNY/tixian.png" alt="" style="width: 42px;">
            <p class="text">提现</p>
          </a>
        </div> 
        <div class="actived-item">
          <a href="#" class="">
            <img src=" ../static/IHNY/zhuanzhang.png" alt="" style="width: 42px;">
            <p class="text">转账</p>
          </a>
        </div>
        <div class="actived-item">
          <a href="#" class="">
          <img src=" ../static/IHNY/xiaofei.png" alt="" style="width: 42px;">
          <p class="text">消费</p>
          </a>
        </div>
        <div class="actived-item">
          <a href="#" class="">
          <img src=" ../static/IHNY/renzheng.png" alt="" style="width: 42px;">
          <p class="text">实名认证</p>
          </a>
        </div>
        <div class="actived-item">
          <a href="#" class="">
          <img src=" ../static/IHNY/fensi.png" alt="" style="width: 42px;">
          <p class="text">粉丝</p>
          </a>
        </div>
      </div>
      <p class="infiTitle">最新资讯</p>
      <div class="infomation">
          <ul>
            <li>
              <p class="content">四大电商平台，五大运营模式</p>
              <span class="date">2019-01-02</span>
            </li>
            <li>
              <p class="content">未来没有电子商务只有新零售</p>
              <span class="date"> 2019-01-03</span>
            </li>
            <mu-flat-button label="MORE+" class="demo-flat-button"/>
          </ul>
      </div>
    </div>
</template>
<script>
export default {
  data(){
    return {
      bounsWidth: document.documentElement.clientWidth-20
    }
  },
  mounted() {
    
  },
  mothods:{

  }
}
</script>

<style>
 .walletPage .login-bg {
    width: 100%;
    height: 165px;
    position: relative;
    padding: 0 10px;
    text-align: center;
    justify-content: center;
    background: url('../../../static/IHNY/1.png');
    background-size: 100% 100%;
}
 .walletPage .login-bg img.touxiang{
  width: 60px;
  height: 60px;
  border-radius: 50%;
  position: relative;
  top: 50px;
  z-index: 1;
}
.walletPage .bouns{
  position: absolute;
  bottom: -50px;
  background: url('../../../static/IHNY/2.png');
  background-size: 100% 100%;
  border-radius: 15px ;
  box-shadow: 0px 0px 5px #ddd;
}
.walletPage .login-bg .bouns .coin{
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 20px;
  margin-top: 5px;
}
.walletPage .login-bg .bouns .totalCoin{
  margin-top: 20px;
}
.walletPage .login-bg .bouns .totalCoin .totalTitle{
  font-size: 18px;
  color: #000;
}
.walletPage .login-bg .bouns .totalCoin .totalTitle .totalNum{
  color: #000;
}
.walletPage .login-bg .bouns .totalCoin .totalTitle .fa-money{
  color: orange;
  padding-right:  5px;
}
.walletPage .bouns p{
  font-size: 26px;
  color: #000;
}
.walletPage .bouns .totalNum{
  line-height:36px;
}
.walletPage .bouns .grant,.walletPage .bouns .put{
  width:33.3%;
  z-index: 1;
}
.walletPage .bouns .grant{
  height: 40px;
}
.walletPage .bouns .put{
  border-left: 1px dotted #ddd;
  height: 40px;
}
.walletPage .bouns .count{
  font-size: 14px;
  line-height: 24px;
}
.walletPage .bouns .text{
  font-size: 12px;
  color: #000;
}
.walletPage .actived-list {
  overflow: hidden;
  margin: 65px 10px 0;
  background: #fff;
  border-radius: 15px;
  padding: 20px 0 15px;
  box-shadow: 0px 0px 5px #ddd;
}
.walletPage .actived-list .actived-item {
    float: left;
    width: 25%;
    text-align: center;
    padding-bottom: 5px;
}
.walletPage .actived-item .text {
    font-size: 14px;
    color: #333;
    padding-top: 2px;
}
.walletPage .infiTitle{
  background: url('../../../static/IHNY/zuixin.png') no-repeat;
  background-size: 100% auto;
  margin: 0 35%;
  text-align: center;
  margin-top: 20px;
  font-size: 16px;
  color: #000;
  width:30%;
  line-height: 8px;
}
.walletPage .infomation{
  padding: 0 10px;
  margin-top: 20px;
  width: 100%;
}
.walletPage .infomation ul{
  width: 100%;
  background: #fff;
  border-radius: 15px;
  padding: 12px 0;
  text-align: center;
  box-shadow: 0px 0px 5px #ddd;
}
.walletPage .infomation ul li{
  padding: 5px 12px;
  overflow: hidden;
  list-style: none;
}
.walletPage .infomation ul li .content{
  float: left;
  font-size: 14px;
  width: 60%;
  text-align: left;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis
}
.walletPage .infomation ul li .date{
  float: right;
}
.walletPage .infomation ul li:before{
  content: "•";
  padding-right: 3px;
  float: left;
}
.walletPage .infomation ul .mu-flat-button.demo-flat-button{
  color: #ff4981;
}
</style>


// WEBPACK FOOTER //
// src/pages/IHNY/wallet.vue